import { colors } from "common/const/colors";
import styled from "styled-components";

export const StyledLink = styled.span`
  color: ${colors.MainBlue};
  cursor: pointer;
  text-decoration: underline;

  &:hover {
    opacity: 0.8;
  }
`;
